import { useCurrentUser } from "@/hooks/useCurrentUser";
import AdminCampaigns from "@/pages/admin/Campaigns";
import MyCampaigns from "@/pages/influencer/MyCampaigns";

export default function CampaignsPage() {
  const { data: user } = useCurrentUser();
  const roles = user?.roles ?? [];
  if (roles.includes("indiqr-admin")) return <AdminCampaigns />;
  return <MyCampaigns />;
}
